import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';
import { ScenarioHistoryComponent } from './scenario-history.component';

@NgModule({
  declarations: [ScenarioHistoryComponent],
  exports: [ScenarioHistoryComponent],
  imports: [CommonModule, TranslateModule, MatIconModule],
})
export class ScenarioHistoryModule {}
